import { create } from 'zustand'

import { FILTER_DEFAULT_SKIP, FILTER_DEFAULT_TAKE } from '@apps-common/config/filter'

//  Search
//  Skip
//  Take

export const DEFAULT_MY_MONITORING_FILTER_STORE_PROPS: IMyMonitoringFilterProps = {
  search: '',
  skip: FILTER_DEFAULT_SKIP,
  take: FILTER_DEFAULT_TAKE
}

export interface IMyMonitoringFilterProps {
  search: string
  skip: number
  take: number
}

interface IMyMonitoringFilterStore extends IMyMonitoringFilterProps {
  setSearch: (value: string) => void
  setSkip: (value: number) => void
  setTake: (value: number) => void
  getSearchParams: () => IMyMonitoringFilterProps
  getFilteredByKeywords: () => string[]
  clear: () => void
}

export const useMyMonitoringFilterStore = create<IMyMonitoringFilterStore>((set, get) => ({
  ...DEFAULT_MY_MONITORING_FILTER_STORE_PROPS,
  setSearch: (value: string) => {
    const { search } = get()

    if (search !== value) {
      set(() => ({ search: value, skip: FILTER_DEFAULT_SKIP }))
    }
  },
  setSkip: (value: number) => set(() => ({ skip: value })),
  setTake: (value: number) => set(() => ({ take: value })),
  getSearchParams: () => {
    const { search, skip, take } = get()

    return {
      search,
      skip,
      take
    }
  },
  getFilteredByKeywords: () => {
    const { search, skip, take } = get()

    const keywords = []

    if (search !== '') {
      keywords.push('Search')
    }

    return keywords
  },
  clear: () => {
    set(() => ({
      ...DEFAULT_MY_MONITORING_FILTER_STORE_PROPS
    }))
  }
}))
